import { useEffect, useState } from 'react';
import ReactDom from 'react-dom';
export var Portal = function (_a) {
    var children = _a.children;
    var container = useState(function () { return document.createElement('div'); })[0];
    useEffect(function () {
        try {
            document.body.appendChild(container);
        }
        catch (e) {
            console.log(e);
        }
        return function () {
            try {
                document.body.removeChild(container);
            }
            catch (e) {
                console.log(e);
            }
        };
    }, []);
    return ReactDom.createPortal(children, container);
};
export default Portal;
